import { useContext, useEffect, useState } from "react";

import CustomDateInput from "../../../helperComponents/CustomDateInput";
import OnboardingBoilerplate from "./OnboardingBoilerplate";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import CustomToggle from "../../../helperComponents/CustomToggle";
import MaterialInput from "../../../helperComponents/MaterialInput";
import styled from "styled-components";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";

const options = [
  { value: "MALE", label: "Mr" },
  { value: "FEMALE", label: "Mme" },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
`;

export default function AskBio({ asEditPage }) {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const { t } = useTranslation();
  const [bio, setBio] = useState("");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loggedInUser) {
      setBio(loggedInUser.bio);
    }
  }, []);

  let title = "Please! tell us about yourself";

  if (loggedInUser.accountType == "NGO") {
    title = "Please! tell us more about this NGO";
  } else if (loggedInUser.accountType == "COMPANY") {
    title = "Please! tell us more about this company";
  }

  return (
    <OnboardingBoilerplate
      editPageTitle="Bio"
      asEditPage={asEditPage}
      skipID={"bioOnboardingSkipped"}
      title={title}
      desc={"Like you purpose, background, motivation..."}
      onSubmit={onSubmit}
      loading={loading}
    >
      <Container>
        <MaterialInput
          multiline={true}
          rows={5}
          label={"Bio"}
          value={bio}
          onChange={extractEventValue(setBio)}
        />
      </Container>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    if (!bio) return window.popupAlert("Please type the bio");
    if (bio.length < 20) return window.popupAlert("bio is too short");

    setLoading(true);

    try {
      await serverLine.patch("/me", {
        changes: { bio },
      });
      setLoading(false);
      let newLoggedInUser = { ...loggedInUser, bio };
      setLoggedInUser(newLoggedInUser);
      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
